import { mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
import {
    ENTERPRISE_TARIFF_NAME,
    FREE_TARIFF_NAME,
    PAYMENT_METHOD_CAPITALIST_NAME,
    PAYMENT_METHOD_CARD_NAME,
    PAYMENT_METHOD_UNLIMINT_NAME,
    PAYMENT_METHOD_STRIPE,
    PAYMENT_METHOD_CLOUDPAY_NAME,
    USDC_BSC_CODE,
    PAYMENT_METHOD_USDT_NAME,
    TRIAL_PERIOD_NAME,
    PAYMENT_METHOD_CRYPTO_NAME,
    PAYMENT_METHOD_CRYPTOMUS_OR_INXY
} from '@/constants/plans'
import moment from "moment";

let balanceRequestsInPending = 0

export default {
    computed: {
        ...mapGetters({
            profile: 'main/profile',
            paymentInfo: 'plans/paymentInfo',
            companyInfo: 'plans/companyInfo'
        }),
        ...mapFields('plans', ['invoice']),
        showPaymentDialogCompanyInfo () {
            return [PAYMENT_METHOD_CARD_NAME, PAYMENT_METHOD_UNLIMINT_NAME, PAYMENT_METHOD_STRIPE].includes(this.paymentInfo.paymentMethod)
        }
    },

    methods: {
        async updatePaymentInfo (renew = false) {
            if (!this.paymentInfo.plan || this.profile.role === 'user') {
                return;
            }

            let profilesCount = this.paymentInfo.profilesCount

            if (typeof profilesCount == 'object') {
                profilesCount = profilesCount.value
            }

            const data = {
                plan: this.paymentInfo.plan,
                countryCode: this.companyInfo.countryCode?.toUpperCase(),
                paymentMethod: this.paymentInfo.paymentMethod,
                usersLimit: parseInt(this.paymentInfo.additionalUsers, 10) + 1,
                browserProfilesLimit: profilesCount,
                provider: 'upgrade',
                promo: this.paymentInfo.promocode ? this.paymentInfo.promocode : null,
                teamId: this.profile.teamId,
                refund: false,
                renew,
                isCustomTariff: this.paymentInfo.isCustomTariff || false
            }

            if (this.paymentInfo.prolongMonths) {
                data.days = parseInt(this.paymentInfo.prolongMonths) * 30
            }

            if (this.companyInfo.vatId) {
                data.vatId = this.companyInfo.vatId
            }

            if (
                !this.paymentInfo.prolongMonths &&
                this.profile.subscription.plan === FREE_TARIFF_NAME &&
                this.profile.subscription.browserProfiles.limit === 10
            ) {
                data.days = 30
            }

            if (data.plan === FREE_TARIFF_NAME) {
                data.browserProfilesLimit = this.paymentInfo.additionalProfiles
                data.browserProfilesLimit += 10
                data.usersLimit = 1
            }

            if (data.plan === ENTERPRISE_TARIFF_NAME && data.browserProfilesLimit < 1000) {
                data.browserProfilesLimit = 1000
            }

            switch (this.paymentInfo.paymentMethod) {
                case PAYMENT_METHOD_CARD_NAME:
                    data.provider = PAYMENT_METHOD_CLOUDPAY_NAME
                    break;
                case PAYMENT_METHOD_CAPITALIST_NAME:
                    data.provider = PAYMENT_METHOD_CAPITALIST_NAME
                    break;
                case PAYMENT_METHOD_USDT_NAME:
                    data.provider = this.paymentInfo.provider || PAYMENT_METHOD_CRYPTOMUS_OR_INXY
                    data.coin = this.paymentInfo.coin || USDC_BSC_CODE

                    break;
                case PAYMENT_METHOD_CRYPTO_NAME:
                    if (this.paymentInfo.provider === PAYMENT_METHOD_CRYPTOMUS_OR_INXY ) {
                        data.provider = PAYMENT_METHOD_CRYPTOMUS_OR_INXY
                        data.paymentMethod = PAYMENT_METHOD_USDT_NAME
                        data.coin = this.paymentInfo.coin
                    }

                    break;
            }

            try {
                if (data.days === 0) {
                    delete data['days']
                }

                balanceRequestsInPending++

                await this.$store.dispatch('plans/setPaymentSummaryUpdating', true)

                const response = await this.api.post('/subscription/balance', data)

                if (response.status === 200 && response.data?.data) {
                    const resp = response.data.data
                    const summary = {
                        planBasePrice: resp.new.basePrice,
                        additionalUsersPrice: resp.new.additionalUsersPrice,
                        additionalProfilesPrice: resp.new.additionalProfilesPrice,
                        paymentFee: resp.new.paymentFee,
                        paymentFeePercentage: resp.new.paymentFeePercentageRate,
                        discount: resp.new.discount,
                        discountPercentage: resp.new.discountPercentageRate,
                        countryFee: resp.new.countryFee,
                        countryFeePercentage: resp.new.countryPercent,
                        total: resp.new.total,
                        availableDays: resp.new.availableDays
                    }

                    await this.$store.dispatch('plans/setPaymentSummary', summary)
                    await this.$store.dispatch('plans/setBalance', resp)
                }
            } catch (error) {
                console.log(error, 'Error on balance update')
            } finally {
                balanceRequestsInPending--

                if (balanceRequestsInPending === 0) {
                    await this.$store.dispatch('plans/setPaymentSummaryUpdating', false)
                }
            }
        },

        setPaymentInterval (interval, invoiceId, closeDialog) {
            return setInterval(async () => {
                const response = await this.api(`/subscription/invoices/${invoiceId}`)

                if (response.data.data.status === 'success') {
                    this.successfulPaymentAlert = true

                    clearInterval(interval)
                    closeDialog()

                    this.$store.dispatch('main/loadProfile')
                    this.$router.push({ name: 'Overview' })
                }
            }, 15000)
        },

        async showNpsQuiz () {
            const { subscription, team } = this.profile
            const haveMinimumTwoSuccessfulInvoices = await this.$store.dispatch('billing/haveMinimumTwoSuccessfulInvoices')

            // Conditions are -
            // user have at least 2 successful invoices
            // user needs to be registered before 2023 february 28th
            // they haven't seen the frame before
            // they have paid plan
            if (
                haveMinimumTwoSuccessfulInvoices &&
                moment(team['created_at']).isBefore('2023-02-28') &&
                !localStorage.getItem('npsQuizShowed') &&
                subscription.plan !== TRIAL_PERIOD_NAME
            ) {
                if (
                    subscription.plan === FREE_TARIFF_NAME &&
                    !subscription.browserProfiles.additionalProfiles &&
                    !subscription.users.additionalUsers
                ) {
                    return
                }

                this.$store.dispatch('main/openDialog', 'npsQuiz')
            }
        },

        openCloudPaymentsWidget (invoiceId, amount, currency, closeDialog) {
            const _this = this

            const widget = new window.cp.CloudPayments({
                language: this.$i18n.locale === 'ru' ? 'ru-RU' : 'en-US'
            })

            widget.charge(
                {
                    publicId: process.env.VUE_APP_CLOUDPAYMENT_KEY, //id из личного кабинета
                    description: this.$t('plans.paymentFor'), //назначение
                    amount: parseFloat(amount), //сумма
                    currency: currency.toUpperCase(), //валюта
                    accountId: this.profile.teamId, //идентификатор плательщика (необязательно)
                    invoiceId: invoiceId, //номер заказа  (необязательно)
                    email: this.profile.username,
                    skin: 'mini', //дизайн виджета (необязательно)
                    data: {
                        cloudPayments: {
                            recurrent: {
                                interval: 'Day',
                                period: 30 * parseInt(this.paymentInfo.prolongMonths, 10)
                            }
                        }
                    }
                },

                function(options) {
                    closeDialog()
                    _this.$store.dispatch('main/loadProfile')
                    _this.$router.push({ name: 'Overview' })
                    _this.successfulPaymentAlert = true
                }
            )
        }
    }
}